<mat-card
    appearance="outlined"
    class="flat mt-10"
    style="margin-bottom: 10px"
>
    <div class="row">
        <div>
            <h3
                [id]="identifierService.labelId('viewAddressContactInfo', 'addressContactHeader')"
                class="merlin-header header-space"
                data-tx-key="label.gb.address_contact"
            >
                {{ labels['label.gb.address_contact'] }}
            </h3>
        </div>
        <div class="pl-15">
            <div>
                <p
                    [id]="identifierService.buttonId('viewAddressContactInfo', 'emergencyContact')"
                    class="sectionTitle popupLink"
                    (click)="onEmergencyContact()"
                    data-tx-key="label.gb.emergency_contact"
                >
                    {{ labels['label.gb.emergency_contact'] }}
                </p>
            </div>
        </div>
    </div>
    <div *ngIf="displayViewUI()">
        <div class="row">
            <div class="col-xs-12">
                <div [id]="identifierService.labelId('viewAddressContactInfo', 'addressText')" class="labelText" data-tx-key="label.gb.address">
                    {{ labels['label.gb.address'] }}
                </div>
                <div class="infoText" style="margin-bottom: 10px" [id]="
                                    identifierService.dropdownId(
                                        'address-contact-information',
                                        'viewAddress'
                                    )
                                ">
                    <span [id]="identifierService.labelId('viewAddressAndContactInformation', 'address1')" *ngIf="patRes?.patient?.address?.address">{{ patRes?.patient?.address?.address }}</span>
                    <span [id]="identifierService.labelId('viewAddressAndContactInformation', 'address2')" *ngIf="patRes?.patient?.address?.address2">, {{ patRes?.patient?.address?.address2 }}</span>
                    <span [id]="identifierService.labelId('viewAddressAndContactInformation', 'address3')" *ngIf="patRes?.patient?.address?.address3">, {{ patRes?.patient?.address?.address3 }}</span>
                    <div>
                        <span [id]="identifierService.labelId('viewAddressAndContactInformation', 'address_city')" *ngIf="patRes?.patient?.address?.city">{{ patRes?.patient?.address?.city }},</span>
                        {{ getState() }} {{ getZipCode() }} {{ getCountry() }}
                    </div>
                </div>
            </div>
        </div>
        <hr /> <br /> <br />
        <div class="row">
            <div class="col-xs-4">
                <div [id]="identifierService.labelId('viewAddressContactInfo', 'primary_phone')" class="labelText" data-tx-key="label.gb.primary_phone">
                    {{ labels['label.gb.primary_phone'] }}
                </div>
                <div class="row">
                    <div class="col-xs-3">
                        <div class="infoText" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'viewCountryCode'
                                )
                            ">
                            {{ patRes?.patient?.phone?.countryCode ? patRes?.patient?.phone?.countryCode : "--" }}
                        </div>
                        <div [id]="identifierService.labelId('viewAddressContactInfo', 'country_code')" class="subText" data-tx-key="label.gb.phone_country_code">
                            {{ labels['label.gb.phone_country_code'] }}
                        </div>
                    </div>
                    <div class="col-xs-4">
                        <div class="infoText" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'viewAreaCode'
                                )
                            "
                        >
                            {{ patRes?.patient?.phone?.areaCode ? patRes?.patient?.phone?.areaCode : "--" }}
                        </div>
                        <div [id]="identifierService.labelId('viewAddressContactInfo', 'area_code')" class="subText" data-tx-key="label.gb.phone_area_code">
                            {{ labels['label.gb.phone_area_code'] }}
                        </div>
                    </div>
                    <div class="col-xs-5">
                        <div class="infoText" [id]="
                                identifierService.dropdownId(
                                    'address-contact-information',
                                    'viewPhoneNum'
                                )
                            "
                        >
                            {{ getPhoneInfo(patRes?.patient?.phone?.phoneNum) ? getPhoneInfo(patRes?.patient?.phone?.phoneNum) : "--" }}
                        </div>
                        <div [id]="identifierService.labelId('viewAddressContactInfo', 'phone_number')" class="subText" data-tx-key="label.gb.phone_number">
                            {{ labels['label.gb.phone_number'] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-3">
                <div [id]="identifierService.labelId('viewAddressContactInfo', 'email_addr')" class="labelText" data-tx-key="label.gb.email_addr">
                    {{ labels['label.gb.email_addr'] }}
                </div>
                <div
                    class="infoText"
                    style="margin-bottom: 10px"
                    [id]="
                        identifierService.dropdownId(
                            'address-contact-information',
                            'viewEmail'
                        )
                    "
                >
                    {{ patRes?.patient?.email ? patRes?.patient?.email : "--" }}
                </div>
            </div>
        </div>
    </div>
</mat-card>
